/** @jsx jsx */
import useSettingsContext from "@src/hooks/useSettingsContext"
import { jsx, Styled } from "theme-ui"

function LogoSmall() {
  const {
    logoSmall: {
      title,
      file: { url },
    },
  } = useSettingsContext()

  return (
    <Styled.img
      alt={title}
      src={url}
      sx={{
        width: "40px",
        height: "40px",
      }}
    />
  )
}
export default LogoSmall
